export const ALL_PLACE_TYPES = [
  'continent',
  'country',
  'province_state',
  'high_level_region',
  'multi_city_vicinity',
  'city',
  'neighborhood',
  'colloquial_area',
  'airport',
  'metro_station',
  'train_station',
  'point_of_interest',
] as const;

export type PlaceType = (typeof ALL_PLACE_TYPES)[number];

export const DEFAULT_ACTIVE_TYPES = new Set<PlaceType>([
  'continent',
  'country',
  'province_state',
  'high_level_region',
  'multi_city_vicinity',
  'city',
  'neighborhood',
  'colloquial_area',
]);
